var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndexLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 18.652,
    viewBox: "0 0 110 18.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(-481.848 -60.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M1213.43,60.752h-1.046l-8.728,18.583h1.026l8.748-18.583Z",
    transform: "translate(-636.426 -0.459)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_654-2",
    "data-name": "Group 654",
    transform: "translate(481.848 60.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M484.8,60.231h5.974l-2.948,18.652h-5.974Z",
    transform: "translate(-481.848 -60.231)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M564.854,60.231h6.652l3.678,9.7,1.539-9.7h5.243l-2.948,18.652h-5.661L568.9,67.849l-1.722,11.035h-5.27Z",
    transform: "translate(-552.436 -60.231)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M738.421,60.231h6.313c6.365,0,9.626,2.948,9.626,7.931,0,6.991-4.461,10.722-10.9,10.722h-7.983ZM743.482,74.4c3.078,0,4.748-2.139,4.748-5.974,0-2.426-1.174-3.7-3.626-3.7h-.965L742.1,74.4Z",
    transform: "translate(-705.472 -60.231)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M905.373,60.231H918.6l-.7,4.539h-7.357l-.417,2.635h5.844l-.626,4.122h-5.843l-.47,2.817H916.8l-.7,4.539h-13.67Z",
    transform: "translate(-852.676 -60.231)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M1035.088,69.075l-3.783-8.844h6.339l1.852,5.27,3.365-5.27h6.1l-6.261,9.052,4.148,9.6h-6.365l-2.27-6.183-4.122,6.183h-6.183Z",
    transform: "translate(-963.321 -60.231)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(578.27 60.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M1297.018,69.977l4.356-3.668c1.121-.943,1.962-1.86,1.962-3.172a1.771,1.771,0,0,0-1.949-1.86,2.528,2.528,0,0,0-2.573,2.254h-.433a2.963,2.963,0,0,1,3.019-2.637,2.169,2.169,0,0,1,2.382,2.229c0,1.478-.93,2.433-2.127,3.426L1297.91,69.7h5.082l-.064.395h-5.936Z",
    transform: "translate(-1296.993 -60.895)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M1354.412,69.977l4.356-3.668c1.121-.943,1.962-1.86,1.962-3.172a1.771,1.771,0,0,0-1.949-1.86,2.528,2.528,0,0,0-2.573,2.254h-.433a2.963,2.963,0,0,1,3.019-2.637,2.169,2.169,0,0,1,2.382,2.229c0,1.478-.93,2.433-2.127,3.426L1355.3,69.7h5.082l-.064.395h-5.936Z",
    transform: "translate(-1347.598 -60.895)",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexLogo);
export default __webpack_public_path__ + "static/media/index-logo.e16caa3737e9a947e28a1d0d3d2254bb.svg";
export { ForwardRef as ReactComponent };